import React from 'react';
import styled from 'styled-components';
import {SettingsButton} from "../SettingsButton";


export const CancelButton = styled(SettingsButton)`  
  margin: 0 7px; 
  z-index:0;
`;